import {Component} from 'panel';

import {template} from './template';
import './index.styl';

export class AuthHeader extends Component<EmptyObj> {
  _useMp23Brand?: boolean;

  get config() {
    return {
      template,
    };
  }

  public isMp23Brand(): boolean {
    // This may seem hacky and fragile but it is the least invasive approach to swap out logos on our auth pages
    // Requirements:
    // - we only need this information when the component is rendered.
    // - It's value will not change.
    // - The class is guaranteed to exists during first render because it is template rendered by django.
    // Unideal alternatives include:
    // - Passing props from components like mp-sign-in all the way down to here. This would require piping through 3 components.
    // - Using panel context to provide information form the mp-sign-in. This is overkill for one plain boolean.

    // Insane chain guarding to ensure it never fails
    this._useMp23Brand = this._useMp23Brand ?? !!document?.body?.classList?.contains(`mp23-brand`);
    return this._useMp23Brand;
  }
}

customElements.define(`auth-header`, AuthHeader);
